import React from 'react';
import { Check } from 'lucide-react';

export function SeoHero({ eyebrow, title, titleAccent, subtitle, bullets = [], actions, trust, media, mediaLabel, heroRef }) {
  return (
    <section ref={heroRef} data-testid="hero-section" className="relative overflow-hidden bg-white pt-14 pb-12 sm:pt-20 sm:pb-16">
      <div className="pointer-events-none absolute -top-40 right-0 h-[480px] w-[480px] rounded-full bg-emerald-100/60 blur-3xl" aria-hidden="true" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          {eyebrow && <p className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-emerald-700 mb-5" data-testid="hero-eyebrow">{eyebrow}</p>}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-[1.05] tracking-tight" data-testid="hero-title">
            {title}{titleAccent && <> <span className="text-emerald-600">{titleAccent}</span></>}
          </h1>
          {subtitle && <p className="mt-5 text-base md:text-lg text-gray-600 max-w-xl" data-testid="hero-subtitle">{subtitle}</p>}
          {bullets.length > 0 && (
            <ul className="mt-6 space-y-2.5" data-testid="hero-bullets">
              {bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-800">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-emerald-600 text-white"><Check className="h-3 w-3" /></span>
                  <span className="text-sm sm:text-base">{b}</span>
                </li>
              ))}
            </ul>
          )}
          {actions && <div className="mt-8 flex flex-col sm:flex-row gap-3">{actions}</div>}
          {trust && <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm text-gray-500">{trust}</div>}
        </div>
        {media && (
          <div className="relative" data-testid="hero-media">
            <div className="absolute -inset-3 rounded-[28px] bg-[#062417] seo-grain shadow-2xl shadow-emerald-900/30" aria-hidden="true" />
            <div className="relative rounded-2xl bg-white p-5 sm:p-7 shadow-xl ring-1 ring-black/5">
              {mediaLabel && <p className="mb-4 text-xs font-semibold uppercase tracking-wider text-emerald-700">{mediaLabel}</p>}
              {media}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default SeoHero;
